var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"size":"small","color":"transparent"},on:{"click":_vm.downloadFile}},[_c('i',{staticClass:"fas fa-file-download"})])}
var staticRenderFns = []

export { render, staticRenderFns }